export const RESOURCE_VISIBILITY = {
  PRIVATE: 'private',
  PUBLIC: 'public',
} as const;

export type ResourceVisibility =
  (typeof RESOURCE_VISIBILITY)[keyof typeof RESOURCE_VISIBILITY];

export const RESOURCE_VISIBILITY_OPTIONS: readonly ResourceVisibility[] = [
  RESOURCE_VISIBILITY.PRIVATE,
  RESOURCE_VISIBILITY.PUBLIC,
] as const;

export const DEFAULT_RESOURCE_VISIBILITY: ResourceVisibility =
  RESOURCE_VISIBILITY.PUBLIC;

export const normalizeResourceVisibility = (
  value?: ResourceVisibility | string | null
): ResourceVisibility => {
  if (value === RESOURCE_VISIBILITY.PRIVATE || value === RESOURCE_VISIBILITY.PUBLIC) {
    return value;
  }

  if (value === 'only_you') {
    return RESOURCE_VISIBILITY.PRIVATE;
  }

  return DEFAULT_RESOURCE_VISIBILITY;
};
